import { useToast } from '@routeback/ui';
import { useEffect } from 'react';
import { useApp } from '../../lib/app';
import { startPush } from '../../lib/push';

/** Registers this phone for push once signed in — mechanics too (Android app only; no-op elsewhere). */
export function PushSetup() {
  const app = useApp();
  const toast = useToast();
  const { company, mode, sync, switchCompany } = app;
  useEffect(() => {
    if (mode !== 'cloud') return;
    void startPush(company.id, (title, body) => {
      toast(`🔔 ${title}${body ? ` — ${body}` : ''}`);
      void sync();
    }, switchCompany).catch((e) => console.warn('[push]', e));
  }, [company.id, mode, sync, switchCompany, toast]);
  return null;
}
